// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__container___2NOwl {\n  /*display: flex;*/\n  width: 100%;\n  flex-direction: column;\n  /*flex: 1;*/\n  box-sizing: border-box;\n}\n\n.css__searchTableContainer___2kiYT {\n  /* min-height: 25vh; */\n}\n\n.css__searchContainer___zVdWf {\n\n}\n\n.css__resultContainer___xA5KF {\n  /*flex: 1;*/\n  overflow-y: auto;\n  max-height: 75vh\n}\n\n.css__resultContainer___xA5KF > h3 {\n    //padding-top: 12px;\n    padding-bottom: 4px;\n  }\n\n.css__search___18jSn {\n  width: 100%;\n  padding-bottom: 10px;\n}\n\n.css__customerTableMockup___1sXkd {\n  width: 100%;\n}\n\n.css__header___gkL09 {\n  margin: 15px 0px 15px 12px;\n}\n\n.css__modelResultContainer___2l-0Y {\n  margin: 0px 0px 15px 0px;\n}\n\n.css__bar___cuuUC {\n  margin-left: 8px;\n}", ""]);
// Exports
exports.locals = {
	"container": "css__container___2NOwl",
	"searchTableContainer": "css__searchTableContainer___2kiYT",
	"searchContainer": "css__searchContainer___zVdWf",
	"resultContainer": "css__resultContainer___xA5KF",
	"search": "css__search___18jSn",
	"customerTableMockup": "css__customerTableMockup___1sXkd",
	"header": "css__header___gkL09",
	"modelResultContainer": "css__modelResultContainer___2l-0Y",
	"bar": "css__bar___cuuUC"
};
module.exports = exports;
